<ng-container>
   <!-- begin::Offcanvas Toolbar Quick Actions -->
   <div
      ktOffcanvas
      [options]="offcanvasOptions"
      id="kt_quick_user"
      class="offcanvas offcanvas-right p-10"
      [ngStyle]="{ overflow: 'hidden' }">
      <div class="offcanvas-header d-flex align-items-center justify-content-between pb-5">
         <h3 class="font-weight-bold m-0">
            Perfil do Usuário
            <small class="text-muted font-size-sm ml-2"></small>
            <!--Aqui pode ser inseridas a qtd de mensagens -->
         </h3>
         <a href="#" class="btn btn-xs btn-icon btn-light btn-hover-primary" id="kt_quick_user_close">
            <i class="ki ki-close icon-xs text-muted"></i>
         </a>
      </div>

      <div class="offcanvas-content" [ngStyle]="{ height: '100vh', overflow: 'hidden' }">
         <div
            [perfectScrollbar]="{ wheelPropagation: false }"
            class="scroll"
            [ngStyle]="{ height: '600px', position: 'relative' }">
            <div class="d-flex align-items-center mt-5">
               <div class="symbol symbol-100 mr-5">
                  <div class="symbol-label" [ngStyle]="{ 'background-image': imgUser }"></div>
                  <i class="symbol-badge bg-success"></i>
               </div>
               <div class="d-flex flex-column">
                  <a href="#" class="font-weight-bold font-size-h5 text-dark-75 text-hover-primary">
                     {{ completeName }}
                  </a>
                  <div class="text-muted mt-1"></div>
                  <!--Inserido Cargo do Usuário-->
                  <div class="navi mt-2">
                     <a href="#" class="navi-item">
                        <span class="navi-link p-0 pb-2">
                           <span class="navi-icon mr-1">
                              <span
                                 class="svg-icon svg-icon-lg svg-icon-primary"
                                 [inlineSVG]="'./assets/media/svg/icons/Communication/Mail-notification.svg'"></span>
                           </span>
                           <span class="navi-text text-muted text-hover-primary">
                              {{ email }}
                           </span>
                        </span>
                     </a>
                  </div>
                  <a (click)="logout()" class="btn btn-light-primary btn-bold"> Sair </a>
               </div>
            </div>

            <div class="separator separator-dashed mt-8 mb-5"></div>

            <div class="navi navi-spacer-x-0 p-0">
               <div class="navi-item">
                  <div class="navi-link">
                     <div class="symbol symbol-40 bg-light mr-3">
                        <div class="symbol-label">
                           <span class="svg-icon svg-icon-md svg-icon-success">
                              <span [inlineSVG]="'./assets/media/svg/icons/General/Notification2.svg'"></span>
                           </span>
                        </div>
                     </div>
                     <div class="navi-text">
                        <div class="font-weight-bold">Entidades</div>
                        <div class="text-muted">
                           {{ entityDescription }}
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</ng-container>
